import { SomarMesesDataAtual } from './SomarMesesDataAtual';

export default SomarMesesDataAtual;